import Translator from 'translator';
import { Map } from 'immutable';
import { SvgUser, SvgTicket } from 'data/common/iconsvg';

export default new Map({
    commercialAgentList: {
        key: 0,
        label: Translator.translate('general.commercialAgents'),
        path: 'commercialAgent',
        right: 'commercialAgentList',
        Icon: SvgUser
    },
    projectList: {
        key: 1,
        label: Translator.translate('general.projects'),
        path: 'project',
        right: 'projectList',
        Icon: SvgTicket
    },
    ticketsgitsList: {
        key: 2,
        label: Translator.translate('general.ticketsgit'),
        path: 'issues',
        right: 'issuesList',
        Icon: SvgTicket
    }
});



// WEBPACK FOOTER //
// ./environments/simulationenr/common/subMenuData.js